module.exports = __webpack_public_path__ + "3666b53eb7efd8541b4f5397f4e40caa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-22.png
// module id = 1758
// module chunks = 0